import React from "react";
import TabBar, { TabBarProps } from "../../../../shared/components/TabBar";
import { MaterialRequest, MaterialRequestExport } from "../../../../data/entities";
import MaterialExportHistory from "../ExportMaterialHistory";
interface MaterialRequestTabNavigationProps {
    materialRequestInfoTab: React.ReactNode;
    materialRequest: MaterialRequest;
}

const MaterialRequestTabNavigation = ({
    materialRequestInfoTab,
    materialRequest,
}: MaterialRequestTabNavigationProps) => {
    const tabs: TabBarProps[] = [
        {
            label: "Thông tin",
            labelEN: "info",
            content: materialRequestInfoTab,
        },
        {
            label: "Xuất kho",
            labelEN: "Storage Export",
            content: <MaterialExportHistory materialRequest={materialRequest} />,
        },
    ];

    return <TabBar tabs={tabs} />;
};

export default MaterialRequestTabNavigation;
